/**
 * Stub for the in-progress asset/device context feature.
 *
 * The real implementation hasn't landed yet — `LitePanel` already calls this
 * hook and renders `DeviceContextCard` with its result, so this stub returns
 * empty state to keep the build green. When the feature is finished, replace
 * this file with the real implementation.
 */

// Shape is intentionally open until the real type is defined.
export type AssetContext = unknown

export interface UseAssetContextResult {
  assetContext: AssetContext | null
  loading: boolean
  // Permissive rest signature so existing call sites compile until the real
  // implementation lands (e.g. LitePanel passes ticketId, contactId, companyId).
  fetchAssets: (...args: unknown[]) => void
}

export function useAssetContext(): UseAssetContextResult {
  return {
    assetContext: null,
    loading: false,
    fetchAssets: () => {},
  }
}
